import { useState } from "react";

const useToggle = (defaultValue: boolean = false):[boolean, () => void] => {
  const [value, setToggleValue] = useState(defaultValue);

  const toggleValue = () => {
    setToggleValue((prev) => !prev);
  };

  return [value, toggleValue];
};

export default useToggle;
